import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import registerServiceWorker, { unregisterServiceWorker } from './registerServiceWorker'

/**
 * Bootstrap a given entry point
 * @param {React.Component} Entry The entry point to bootstrap
 * @returns {void} void
 */
const bootstrap = (Entry) => {
  ReactDOM.render(<Entry />, document.getElementById(`root`))
  // registerServiceWorker()
  // unregisterServiceWorker()
}

export default bootstrap
